module.exports = __webpack_public_path__ + "static/media/kjedelig.b5e07337.mp3";